import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { AddUpdatePackageResData } from "./AddUpdatePackageResData";

const ENDPOINT = "/device_update/package";

export class AddUpdatePackageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    newFormData: FormData = new FormData();

    constructor(files: any) {
        super();
        this.newFormData = new FormData();
        for (var i = 0; i < files.length; i++) {
            let file = files[i];
            this.newFormData.append("files[" + i + "]", file, file.name);
        }
    }

    public async execute(): Promise<AddUpdatePackageResData> {
        var res = await this.executeCommand(this.newFormData, { "Content-Type": "multipart/form-data" });
        return new AddUpdatePackageResData(res);
    }
}
